import { SvgIcon } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import { toggleVisibilityCalendarInScheduleHeader } from "@/store/ui/ui";
import { RootState } from "@/store/store";
import { toast } from "react-toastify";
import useGetRole from "@/hooks/useGetRole";
import { adminMessage, visitMessage } from "@/utils/constants";

export const IconCalendar = () => {
    const dispatch = useDispatch();
    const { isAdmin } = useGetRole();
    const isVisibleCalendarInSheduleHeader = useSelector(
        (state: RootState) => state.ui.isVisibleCalendarInSheduleHeader,
    );
    const isAppointmentComplete = useSelector(
        (state: RootState) =>
            state.appointments.existtAppointment.isAppointmentComplete,
    );

    function openCalendar() {
        if (isAdmin) {
            if (!isAppointmentComplete) {
                dispatch(
                    toggleVisibilityCalendarInScheduleHeader(
                        !isVisibleCalendarInSheduleHeader,
                    ),
                );
            } else toast.error(visitMessage);
        } else toast.error(adminMessage);
    }
    return (
        <SvgIcon onClick={openCalendar} style={{ cursor: "pointer" }}>
            <image href='/scheduleHeader/calendar.svg' width='24' height='24' />
        </SvgIcon>
    );
};
